import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";

import { API } from "@/App";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { QHubBuddyLogo, QHubFooter } from "@/components/QHubBranding";

const InviteAccept = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const token = params.get("token") || "";

  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [acceptedConsent, setAcceptedConsent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!token) setError("Token inválido o faltante.");
  }, [token]);

  const submit = async () => {
    try {
      setLoading(true);
      setError("");
      try {
        await axios.post(`${API}/auth/accept-invite-v2`, {
          token,
          name,
          password,
          accepted_consent: acceptedConsent,
        });
      } catch (err) {
        // If user already exists, treat invite as password reset
        if (err?.response?.data?.detail === "Email already registered") {
          await axios.post(`${API}/auth/reset-password-v2`, { token, password });
        } else {
          throw err;
        }
      }

      setDone(true);
      setTimeout(() => navigate("/login"), 1200);
    } catch (e) {
      setError(e?.response?.data?.detail || "No se pudo activar la invitación.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-mesh" data-testid="invite-accept">
      <header className="qhub-header">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <QHubBuddyLogo size="default" />
            <Button variant="outline" onClick={() => navigate("/login")}>Volver</Button>
          </div>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-4 py-10">
        <div className="w-full max-w-md bg-white rounded-3xl p-8 border border-gray-100 shadow-xl shadow-gray-200/50">
          <h1 className="text-2xl font-bold font-['Outfit'] text-gray-900 mb-2">Activar invitación</h1>
          <p className="text-sm text-gray-500 mb-6">Crea tu contraseña para acceder a QHUB.BUDDY.</p>

          {done ? (
            <div className="p-4 rounded-2xl bg-green-50 border border-green-100 text-green-800 text-sm">
              Cuenta activada. Redirigiendo a login...
            </div>
          ) : (
            <div className="space-y-3">
              <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Nombre" />
              <Input value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Contraseña" type="password" />

              <div className="flex items-center gap-2 pt-1">
                <Checkbox checked={acceptedConsent} onCheckedChange={(v) => setAcceptedConsent(Boolean(v))} id="consent" />
                <label htmlFor="consent" className="text-xs text-gray-500">
                  Acepto consentimiento (solo requerido si esta invitación es para un padre/madre).
                </label>
              </div>

              {error ? <p className="text-xs text-red-600">{error}</p> : null}

              <Button
                onClick={submit}
                disabled={!token || !name || !password || loading}
                className="w-full h-11 rounded-xl bg-gradient-to-r from-[#419cca] to-[#8b5cf6] text-white"
              >
                {loading ? "Activando..." : "Activar"}
              </Button>
            </div>
          )}
        </div>
      </main>

      <QHubFooter />
    </div>
  );
};

export default InviteAccept;
